class MobileNav extends HTMLElement {
  constructor() {
    super();

    this.debounceHandleOpenSubmenu = this.debounce(
      this.handleOpenSubmenu.bind(this),
      200
    );
    this.debounceHandleOpenNestedSubmenu = this.debounce(
      this.handleOpenNestedSubmenu.bind(this),
      200
    );
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.domElements();
    this.bindListeners();
  }

  domElements() {
    this.menusFirstLevel = this.querySelectorAll(
      ".menu-accordion-content.menu-accordion-content--first-level"
    );
  }

  bindListeners() {
    if (!this.clickHandler) {
      this.clickHandler = (e) => {
        const target = e.target;
        if (target.closest(".accordion-button--first-level")) {
          this.debounceHandleOpenSubmenu(e);
          return;
        }
        if (target.closest(".accordion-button--second-level")) {
          this.debounceHandleOpenNestedSubmenu(e);
          return;
        }
      };
    }
    this.removeEventListener("click", this.clickHandler);
    this.addEventListener("click", this.clickHandler);
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  handleOpenSubmenu(e) {
    const accordionItem = e.target.closest(".menu-accordion-item");
    if (!accordionItem) return;

    const subMenu = accordionItem.querySelector(".menu-accordion-content");
    if (!subMenu) return;

    if (subMenu.classList.contains("show")) {
      subMenu.style.maxHeight = null;
      subMenu.classList.remove("show");
      this.handleCloseNestedSubmenus(subMenu);
      return;
    }

    // close all
    this.handleCloseSubmenus();

    subMenu.style.maxHeight = subMenu.scrollHeight + 5 + "px";
    subMenu.classList.add("show");
  }

  handleCloseSubmenus() {
    if (!this.menusFirstLevel.length) return;

    this.menusFirstLevel.forEach((menu) => {
      menu.style.maxHeight = null;
      menu.classList.remove("show");
    });
  }

  handleOpenNestedSubmenu(e) {
    const submenuAccordionItem = e.target.closest(".sub-menu-accordion-item");

    if (!submenuAccordionItem) return;

    const firstLevelSubmenu = submenuAccordionItem.closest(
      ".menu-accordion-content.menu-accordion-content--first-level"
    );

    if (!firstLevelSubmenu) return;

    const firstLevelSubmenuScrollHeight = firstLevelSubmenu.scrollHeight;

    const nestedSubmenu = submenuAccordionItem.querySelector(
      ".sub-menu-accordion-content.sub-menu-accordion-content--second-level"
    );

    if (!nestedSubmenu) return;

    if (nestedSubmenu.classList.contains("show-nested")) {
      firstLevelSubmenu.style.maxHeight = firstLevelSubmenuScrollHeight + "px";
      nestedSubmenu.style.maxHeight = null;
      nestedSubmenu.classList.remove("show-nested");
      return;
    }

    this.handleCloseNestedSubmenus(firstLevelSubmenu);

    firstLevelSubmenu.style.maxHeight =
      firstLevelSubmenuScrollHeight + nestedSubmenu.scrollHeight + "px";
    nestedSubmenu.style.maxHeight = nestedSubmenu.scrollHeight + "px";
    nestedSubmenu.classList.add("show-nested");
  }

  handleCloseNestedSubmenus(parentSubmenu) {
    const nestedSubmenus = parentSubmenu.querySelectorAll(
      ".sub-menu-accordion-content.sub-menu-accordion-content--second-level"
    );

    if (!nestedSubmenus.length) return;

    nestedSubmenus.forEach((nestedSubmenu) => {
      nestedSubmenu.style.maxHeight = null;
      nestedSubmenu.classList.remove("show-nested");
    });
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.clickHandler);
  }
}

customElements.define("mobile-nav", MobileNav);
